'use client';

import dynamic from 'next/dynamic';
import { ComponentTypes } from '../../../interfaces';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { PlaceholderType } from './types';
import { PlaceholderTypes } from './types';

const DynamicComponentContactForm = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_ContactForm' */ '../Forms/Contact/ContactForm.client').then(
      (mod) => mod.ContactForm,
    ),
  { ssr: false },
);

const DynamicRateProtectionForm = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_RateProtectionForm' */ '../Forms/RateProtection/RateProtectionForm.client'
    ).then((mod) => mod.RateProtectionForm),
  { ssr: false },
);

const DynamicBraFinder = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_BraFinder' */ '../BraFinder/BraFinder.client').then(
      (mod) => mod.BraFinder,
    ),
  { ssr: false },
);

export const Placeholder = ({ data }: { data: PlaceholderType }) => {
  const { field_placeholder_variants: variant } = data;

  switch (variant as PlaceholderTypes) {
    case PlaceholderTypes.ContactForm:
      return <DynamicComponentContactForm />;
    case PlaceholderTypes.RateProtectionType:
      return <DynamicRateProtectionForm />;
    case PlaceholderTypes.BraFinder:
      return <DynamicBraFinder />;
    default:
      return null;
  }
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.Placeholder]: Placeholder });
